import { memo } from "react";
import { Provider } from "react-redux";

import { store } from "../../redux/store";

type ReduxProviderProps = {
   children: React.ReactNode;
};

function ReduxProvider({ children }: ReduxProviderProps) {
   return <Provider store={store}>{children}</Provider>;
}

export default memo(ReduxProvider);
